import * as React from 'react';
import styled, { keyframes } from 'styled-components';

interface IProps {
  thickness?: number;
  diameter?: number;
  speed?: number;
  color?: string;
}

const Spin = keyframes`
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
`;

const LoadingSpinnerNode = styled.div`
  display: inline-block;
  position: relative;
  height: ${(props: IProps) => `${props.diameter}px`};
  width: ${(props: IProps) => `${props.diameter}px`};

  div {
    animation: ${(props: IProps) => `${Spin} ${props.speed}ms cubic-bezier(.5, 0, .5, 1) infinite`};
    border: ${(props: IProps) => `${props.thickness}px solid ${props.color}`};
    border-color: transparent;
    border-top-color: ${(props: IProps) => props.color};
    border-radius: 50%;
    box-sizing: border-box;
    display: block;
    height: ${(props: IProps) => `${props.diameter}px`};
    position: absolute;
    width: ${(props: IProps) => `${props.diameter}px`};
  }

  div:nth-child(1) {
    animation-delay: ${(props: IProps) => `-${(props.speed / 8) * 3}ms`};
  }

  div:nth-child(2) {
    animation-delay: ${(props: IProps) => `-${props.speed / 4}ms`};
  }

  div:nth-child(3) {
    animation-delay: ${(props: IProps) => `-${props.speed / 8}ms`};
  }
`;

const LoadingSpinner: React.FC<IProps> = ({
  thickness = 4,
  diameter = 64,
  speed = 1200,
  color = '#ffb432',
}) => (
  <LoadingSpinnerNode thickness={thickness} diameter={diameter} speed={speed} color={color}>
    <div />
    <div />
    <div />
    <div />
  </LoadingSpinnerNode>
);

export default LoadingSpinner;
